// 검차 셸 카드 — 시안 `.card` + `.chead`. props: { title, count, right, pad, style, children }
import React from 'react';
import { T, R, FONT } from '../../theme';

var wrap = { background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, overflow: 'clip' };
var head = { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderBottom: '1px solid ' + T.bd, background: T.head };
var title = { fontSize: FONT.cardTitle, fontWeight: 800, color: T.ink, letterSpacing: '-.2px' };
var count = { fontSize: 12, color: T.muted, fontVariantNumeric: 'tabular-nums' };
var right = { marginInlineStart: 'auto', display: 'flex', alignItems: 'center', gap: 10 };

function SimpleCard(props) {
  var hasHead = props.title || props.count != null || props.right;
  return (<div className="ss-card" style={props.style ? Object.assign({}, wrap, props.style) : wrap}>
    {hasHead ? (<div style={head}>
      {props.title ? <b style={title}>{props.title}</b> : null}
      {props.count != null ? <span style={count}>{props.count}</span> : null}
      {props.right ? <span style={right}>{props.right}</span> : null}
    </div>) : null}
    <div style={props.pad ? { padding: props.pad } : undefined}>{props.children}</div>
  </div>);
}

export default SimpleCard;
